import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useHistory } from 'react-router-dom'

import Pagination from 'util/modules/Pagination'

import { formatDateTime } from 'util/masks'
import { ApplicationState } from 'AppReducer'
import { deletePartner, getPartnerList } from 'panel/partner/redux/actions'

const PartnerList: React.FC = () => {
  const dispatch = useDispatch()
  const { partnerList: { items, pagination } } = useSelector((state: ApplicationState) => state.partnerReducer)
  const { categoryList: { items: categories } } = useSelector((state: ApplicationState) => state.categoryReducer)

  const history = useHistory()
  const { location: { search } } = history

  const handleFetch = useCallback((): void => {
    const query = new URLSearchParams(search)

    const urlQuery = Object.fromEntries(query.entries())

    const defaultQuery = {
      page: 1,
      limit: 10,
      'sort[name]': 'ASC',
      fields: 'id,pictureTiny,name,c.name,createdAt,updatedAt'
    }

    getPartnerList(query.get('page') ? urlQuery : defaultQuery)(dispatch)
  }, [search, dispatch])

  function handleRemove (id: number): void {
    if (window.confirm('Tem certeza que deseja remover este parceiro?')) {
      deletePartner(id)(dispatch).then(res => {
        if (res?.status === 'success') {
          history.push('/panel/partner')
        }
      })
    }
  }

  useEffect(() => {
    handleFetch()
  }, [handleFetch])

  const gridTemplateColumns = '60px 1fr 300px 200px 200px 305px'

  return (
    <>
      <h2 className="margin-top-32"><i className="fa fa-history"/> Parceiros Cadastrados</h2>
      <div className="list">
        <div className="list-header" style={{ display: 'grid', gridTemplateColumns }}>
          <div/>
          <div>Nome</div>
          <div>Categoria</div>
          <div>Criado em</div>
          <div>Atualizado em</div>
          <div>Ações</div>
        </div>

        {
          items.map(partner => {
            return (
              <div className="list-row" key={partner.id} style={{ display: 'grid', gridTemplateColumns }}>
                <img src={partner.pictureTiny} width={48} height={48} alt="" />

                <div>{ partner.name }</div>
                <div>{ partner.category?.name }</div>
                <div>{ formatDateTime(partner.createdAt) }</div>
                <div>{ formatDateTime(partner.updatedAt, '...') }</div>

                <div className="row">
                  <span
                    onClick={(): void => handleRemove(partner.id)}
                    className="button remove margin-right-8"
                    style={{ width: 48 }}
                  >
                    <i className="fa fa-trash"/>
                  </span>
                  <NavLink
                    style={{ width: 100 }}
                    className="button primary"
                    to={`/panel/partner/${partner.id}${search}`}
                  >
                    Editar
                  </NavLink>

                  <NavLink
                    className="button secondary"
                    style={{ width: 140, marginLeft: 8 }}
                    to={`/panel/partner/${partner.id}/config`}
                  >
                    <i className="fa fa-cogs hidden-mobile" /> Configurar
                  </NavLink>
                </div>
              </div>
            )
          })
        }
        {
          items.length === 0 &&
          <div className="list-row">
            <div className="grid-span">Nenhum parceiro cadastrado</div>
          </div>
        }
      </div>
      <Pagination pagination={pagination} />
    </>
  )
}

export default PartnerList
